export const initialState = {
  fromdb: null,
  tablePages: 0,
  toDownload: null,
  creditOrderDetails: null,
  successModal: {
    show: false,
    message: null,
    redirect: null,
  },
  errorModal: {
    show: false,
    message: null,
    redirect: null,
  },
  isLoading: false,
  error: null,
};
